"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.ManualColumnResize = void 0;
var _manualColumnResize = require("./manualColumnResize");
exports.PLUGIN_KEY = _manualColumnResize.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _manualColumnResize.PLUGIN_PRIORITY;
exports.ManualColumnResize = _manualColumnResize.ManualColumnResize;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/manualColumnResize/index.js
// module id = 1463
// module chunks = 0